import * as React from 'react';
import View from './view';
import {Route} from '@react-navigation/native';
import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../redux';
import {getStateAssignments} from '../../redux/actions/socialSupport/stateAssignments';
import {SocialSupportListData} from '../../shared/components/socialSupportList/model';
import {StateAssignment} from '../../shared/models/socialSupport/stateAssignments';
import {stateAssignmentSelector} from '../../redux/selectors/socialSupport/stateAssignments';

const stateAssignmentsToSocialSupportListData = (data: StateAssignment[]): SocialSupportListData[] => {
  return data.map((program) => ({
    title: program.serviceName,
    children: [
      {
        title: '',
        table: {
          columns: [
            {field: 'serviceContent1', title: 'Содержание услуги 1'},
            {field: 'serviceContent2', title: 'Содержание услуги 2'},
            {field: 'serviceContent3', title: 'Содержание услуги 3'},
            {field: 'service1Form', title: 'Форма оказания услуги 1'},
            {field: 'service2Form', title: 'Форма оказания услуги 2'},
            {field: 'volumeIndicatorName', title: 'Наименование показателя объёма'},
            {field: 'volumeUnit', title: 'Единица измерения показателя объёма'},
          ],
          data: program.rows,
        },
      },
    ],
  }));
};

export const StateAssignmentsScreen = ({route}: {route: Route<string>}) => {
  const dispatch = useAppDispatch();
  const stateAssignments = useSelector(stateAssignmentSelector());
  useEffect(() => {
    if (!stateAssignments) {
      dispatch(getStateAssignments());
    }
  }, [stateAssignments]);
  const socialSupportData = stateAssignmentsToSocialSupportListData(stateAssignments ?? []);
  return <View route={route} socialSupportData={socialSupportData} />;
};
